import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Flèche « Retour » — navigation douce (SPA) vers la page précédente afin de
// conserver les données/filtres déjà saisis. Repli vers `fallback` si aucun
// historique interne n'existe (accès direct par lien).
export function BackButton({ fallback = "/", label = "Retour", className = "" }) {
  const navigate = useNavigate();
  const onBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };
  return (
    <button
      type="button"
      onClick={onBack}
      data-testid="back-button"
      aria-label={label}
      className={`group inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition-colors duration-200 hover:border-ciel hover:text-navy ${className}`}
    >
      <ArrowLeft size={16} className="transition-transform duration-200 group-hover:-translate-x-0.5" />
      {label}
    </button>
  );
}

// Barre fine contenant la flèche Retour, alignée à gauche en haut de page.
export function BackBar({ fallback = "/" }) {
  return (
    <div className="border-b border-slate-100 bg-white/70 backdrop-blur-sm" data-testid="back-bar">
      <div className="mx-auto max-w-7xl px-6 py-3">
        <BackButton fallback={fallback} />
      </div>
    </div>
  );
}
